import React from "react";
import popular from "./popular2.png";

const Popular1 = () => {
  return (
    <div className="container">
      <img className="img-fluid" src={popular} width={"100%"} alt="" />
    </div>
  );
};

export default Popular1;
